<template>
  <div class="ad-wrapper">
    <a :href="adInfo.url" target="_blank">
      <img :src="adInfo.atturl" alt="ads">
    </a>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: [
    'adInfo'
  ],
  methods: {
    formatterDate(num) {
      let diff = num - moment().second();

      // console.log(diff);
      return diff;
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/css/home-page/banner-square/ads.less";
// .ad-wrapper {
//   width: 380px;
//   position: relative;

//   p {
//     position: absolute;
//     top: 10px;
//     left: 10px;
//   }

//   a {
//     display: block;
//   }
//   img {
//     width: 100%;
//     height: 100%;
//     border-radius: 10px;
//   }
// }
</style>



// WEBPACK FOOTER //
// ads.vue?c29131c8